module.exports = __webpack_public_path__ + "static/img/girl2.e170039.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/girl2.svg
// module id = tXcJ
// module chunks = 1